// /api/common/v1/reoprt/pdfVerify
export const pdfVerifyAddressPath = "http://8.131.51.198:8069/restful/api/common/v1/reoprt/pdfVerify"